module.exports = __webpack_public_path__ + "img/touxiang.4c276b82.jpg";